





























import type { PropType } from '@vue/composition-api';
import { ref, defineComponent } from '@vue/composition-api';
import ChatFab from '@getaccept/lib-shared/src/chat/components/ChatFab.vue';
import type { EntityTheme } from '@getaccept/lib-shared/src/types/theme';
import { SlideOrigin } from '@getaccept/lib-ui';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { DsrConstants } from '@getaccept/dsr-shared';
import ChatWrapper from '../chat/components/ChatWrapper.vue';

export default defineComponent({
  name: 'SlideChat',
  components: {
    ChatWrapper,
    ChatFab,
  },
  props: {
    theme: {
      type: Object as PropType<EntityTheme>,
      default: null,
    },
    recipient: {
      type: Object as PropType<Recipient>,
      required: true,
    },
  },
  setup() {
    const showSlideChat = ref(false);

    return {
      showSlideChat,
      SlideOrigin,
      DsrConstants,
    };
  },
});
